import { callFunction } from "./functions-client";

// Two-factor (TOTP) management via the identity function (GoTrue MFA).

export interface EnrollResult {
  factor_id: string;
  qr_code: string;
  secret: string;
  uri: string;
}

export interface TwoFactorStatus {
  enabled: boolean;
  factors: { id: string; status: string; factor_type: string }[];
}

export const enroll2fa = () => callFunction<EnrollResult>("identity/2fa-enroll", { body: {} });

export const verify2fa = (factor_id: string, code: string) =>
  callFunction<{ ok: boolean; access_token?: string; refresh_token?: string }>("identity/2fa-verify", {
    body: { factor_id, code },
  });

export const status2fa = () => callFunction<TwoFactorStatus>("identity/2fa-status", { method: "GET" });

export const disable2fa = (factor_id: string) =>
  callFunction<{ ok: boolean }>("identity/2fa-disable", { body: { factor_id } });

// Email one-time-code second factor (custom; see identity email-2fa-* actions).
export interface EmailMfaStatus { enabled: boolean; }
export const emailMfaStatus = () => callFunction<EmailMfaStatus>("identity/email-2fa-status", { method: "GET" });
export const emailMfaSend = () => callFunction<{ ok: boolean }>("identity/email-2fa-send", { body: {} });
export const emailMfaEnable = (code: string) => callFunction<{ ok: boolean; enabled: boolean }>("identity/email-2fa-enable", { body: { code } });
export const emailMfaVerify = (code: string) => callFunction<{ ok: boolean }>("identity/email-2fa-verify", { body: { code } });
export const emailMfaDisable = () => callFunction<{ ok: boolean }>("identity/email-2fa-disable", { body: {} });
